// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostFeedbackRequestModel from '../../model/post-feedback-request-model';
import PostFeedbackRequestDTO from '../dto/post-feedback-request-dto';
import dtoSchema from '../schemas/post-feedback-request-schema';

export default abstract class PostFeedbackRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostFeedbackRequestDTO>) {
    super();
    if (data) {
      this.companyId = data.companyId;
      this.eventRating = data.eventRating;
      this.reparticipationRating = data.reparticipationRating;
      this.youthVisitorsCount = data.youthVisitorsCount;
      this.adultVisitorsCount = data.adultVisitorsCount ?? undefined;
      this.remark = data.remark ?? undefined;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  * @type {int32}
  */
  eventRating?: number;
  /**
  * @type {int32}
  */
  reparticipationRating?: number;
  /**
  * @type {int32}
  */
  youthVisitorsCount?: number;
  /**
  * @type {int32}
  */
  adultVisitorsCount?: number;
  /**
  */
  remark?: string;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<PostFeedbackRequestDTO>): PostFeedbackRequestModel;
  static toModel(dto: DeepPartial<PostFeedbackRequestDTO> | undefined | null): PostFeedbackRequestModel | undefined;
  static toModel(dto: DeepPartial<PostFeedbackRequestDTO> | undefined | null): PostFeedbackRequestModel | undefined {
    return dto ? new PostFeedbackRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostFeedbackRequestModel> | PostFeedbackRequestModel): PostFeedbackRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      companyId: unwrapped.companyId,
      eventRating: unwrapped.eventRating,
      reparticipationRating: unwrapped.reparticipationRating,
      youthVisitorsCount: unwrapped.youthVisitorsCount,
      adultVisitorsCount: unwrapped.adultVisitorsCount,
      remark: unwrapped.remark,
      eventIdentifier: unwrapped.eventIdentifier,
    } as PostFeedbackRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostFeedbackRequestModel, can not map to PostFeedbackRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
